import React from 'react';

var img1 = require('./../../images/background/bg-6.png');
var img2 = require('./../../images/background/line.png');

class AboutSummary extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b80 bg-dark bg-repeat square_shape2 inner-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator text-white">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">About</span> Summary</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        <div className="section-content our-story">
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img style={{
                                                width: "632px",
                                                height: "510px",
                                                objectFit: "cover"
                                            }} src={require('./../../images/projects/ecospark/img126.jpg')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">Pre-2021</h4>
                                        <h4 className="m-b20">Early Construction Roots</h4>
                                        <p>ALT construction was initially involved in the construction of buildings, small weirs, and electro-mechanical works, laying the historical foundation for the current company.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img style={{
                                                width: "632px",
                                                height: "510px",
                                                objectFit: "cover"
                                            }} src={require('./../../images/projects/ecospark/img120.jpg')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">January 2021</h4>
                                        <h4 className="m-b20">Establishment of Ecospark</h4>
                                        <p>ECOSPARK ENGINEERING PLC was officially formed by the current general manager, initially focusing on supplying and installing electro-mechanical systems, swimming pools, treatment plants, and sanitary systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img style={{
                                                width: "632px",
                                                height: "510px",
                                                objectFit: "cover"
                                            }} src={require('./../../images/projects/ecospark/img169.jpg')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2021 - 2022</h4>
                                        <h4 className="m-b20">Gaining Market Confidence</h4>
                                        <p>Despite being a relatively new operator, the company quickly gained the confidence and goodwill of many by providing affordable, user-friendly, and high-quality technological innovations.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img style={{
                                                width: "632px",
                                                height: "510px",
                                                objectFit: "cover"
                                            }} src={require('./../../images/projects/ecospark/img155.jpg')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">2023</h4>
                                        <h4 className="m-b20">Business Transformation</h4>
                                        <p>After achieving its original goals, the company transformed its business plan to manage water supply and implement both small and high-scale electro-mechanical and construction projects.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutSummary;